import { useQuery } from '@tanstack/react-query'
import { tenantsApi } from '@/lib/api'
import { Link } from 'react-router-dom'
import { Plus, Edit, Trash2, ShieldAlert } from 'lucide-react'
import { formatDate } from '@/lib/utils'
import { useAuth } from '@/contexts/AuthContext'

export default function TenantsPage() {
  const { user } = useAuth()
  const isSuperAdmin = user?.roles?.some(r => r.name === 'SUPER_ADMIN') || user?.permissions?.includes('*') || false

  const { data, isLoading } = useQuery({
    queryKey: ['tenants'],
    queryFn: () => tenantsApi.list({ page: 1, page_size: 20 }),
    enabled: isSuperAdmin,
  })

  if (!isSuperAdmin) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <ShieldAlert className="h-12 w-12 text-gray-300 mb-4" />
        <h2 className="text-lg font-semibold text-gray-700">Acesso Restrito</h2>
        <p className="mt-1 text-sm text-gray-500">Esta secção é exclusiva para administradores do sistema.</p>
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Tenants</h1>
          <p className="mt-1 text-sm text-gray-600">
            Gerir organizações do sistema
          </p>
        </div>
        <Link to="/tenants/new" className="btn btn-primary">
          <Plus className="mr-2 h-4 w-4" />
          Novo Tenant
        </Link>
      </div>

      <div className="mt-6 card">
        {isLoading ? (
          <div className="flex justify-center py-12">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent"></div>
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Slug</th>
                <th>Plano</th>
                <th>Utilizadores</th>
                <th>Status</th>
                <th>Criado em</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {data?.data.items.map((tenant) => (
                <tr key={tenant.id}>
                  <td className="font-medium">{tenant.name}</td>
                  <td className="text-gray-600">{tenant.slug}</td>
                  <td>
                    <span className="badge badge-info">
                      {tenant.subscription_tier}
                    </span>
                  </td>
                  <td className="text-gray-600">
                    {tenant.users_count || 0} / {tenant.max_users}
                  </td>
                  <td>
                    {tenant.is_active ? (
                      <span className="badge badge-success">Ativo</span>
                    ) : (
                      <span className="badge badge-danger">Inativo</span>
                    )}
                  </td>
                  <td className="text-gray-600">
                    {formatDate(tenant.created_at)}
                  </td>
                  <td>
                    <div className="flex gap-2">
                      <Link
                        to={`/tenants/${tenant.id}/edit`}
                        className="rounded p-1 text-blue-600 hover:bg-blue-50"
                      >
                        <Edit className="h-4 w-4" />
                      </Link>
                      <button className="rounded p-1 text-red-600 hover:bg-red-50">
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
